// extracted by mini-css-extract-plugin
export default {"container":"styles_container__bkZGh","text":"styles_text__9uqhI","text__gray":"styles_text__gray__62IHx","subtitle":"styles_subtitle__DWGp8"};